import { z } from "zod";

import { type FormValidationOutput } from "./base";

const verificationCodeSchema = z
  .string()
  .min(6, "Code must be 6 characters in length")
  .max(6, "Code must be 6 characters in length")
  .regex(/^\d{6}$/, "Code must be 6 digits");

export function isVerificationCodeValid(input: string): FormValidationOutput {
  try {
    verificationCodeSchema.parse(input);
    return { isValid: true, message: "" };
  } catch (e) {
    if (e instanceof z.ZodError) {
      return {
        isValid: false,
        message: e.issues[0]?.message ?? "Invalid verification code.",
      };
    }
    return { isValid: false, message: "The verification code is invalid. " };
  }
}
